import React from 'react';
import { formatCurrency } from '@/utils/Formatters/formatCurrency';
import { formatDate } from '@/utils/Formatters/formatDate';
import { Button } from 'gatorcomponents';
import * as Styles from './InvoiceInfos.styles';

const InvoiceInfos = ({
  mobile,
  showInvoiceDetails,
  invoiceDetailsLocale,
  invoiceDetailsState,
  invoice,
  handleSeeDetails,
}) => {
  const detailsButtonLabel = showInvoiceDetails
    ? invoiceDetailsLocale.hideDetailsButtonLabel
    : invoiceDetailsLocale.showDetailsButtonLabel;

  return (
    <Styles.InvoiceInfoWrapper>
      {invoice && (!mobile || showInvoiceDetails) && (
        <>
          <Styles.InvoiceInfo>
            <Styles.InvoiceInfoTitle>{invoiceDetailsLocale.invoice}</Styles.InvoiceInfoTitle>
            {invoice && invoice.id}
          </Styles.InvoiceInfo>
          <Styles.InvoiceInfo>
            <Styles.InvoiceInfoTitle>{invoiceDetailsLocale.dueDate}</Styles.InvoiceInfoTitle>
            {formatDate(invoice.duedate)}
          </Styles.InvoiceInfo>
          <Styles.InvoiceInfo>
            <Styles.InvoiceInfoTitle>{invoiceDetailsLocale.totalValue}</Styles.InvoiceInfoTitle>
            {formatCurrency(invoice.total)}
          </Styles.InvoiceInfo>
        </>
      )}
      {(!mobile || !showInvoiceDetails) && (
        <Button
          label={detailsButtonLabel}
          variant="text"
          onClick={handleSeeDetails}
          loading={invoiceDetailsState.loading}
          disabled={invoiceDetailsState.loading}
        />
      )}
    </Styles.InvoiceInfoWrapper>
  );
};

export default InvoiceInfos;
